/* LUVF motion layer - no dependencies, theme-editor safe.
   Scoped to .luvf sections so it never interferes with Dawn's own
   header, menu drawer, cart drawer or predictive search. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('luvf-anim');

  var GROUPS = [
    ['.luvf-hero h1 span', 'rise-lg', 90],
    ['.luvf-hero .luvf-eyebrow, .luvf-hero-sub, .luvf-hero-cta', 'rise', 70],
    ['.luvf-head > *', 'rise', 80],
    ['.luvf-door', 'scale', 110],
    ['.luvf-dish', 'scale', 90],
    ['.luvf-plan', 'left', 60],
    ['.luvf-stat', 'rise', 100],
    ['.luvf-pt, .luvf-tl', 'rise', 70],
    ['.luvf-split img, .luvf-split .luvf-ph', 'scale', 0],
    ['.luvf-bake-imgs img, .luvf-bake-imgs .luvf-ph', 'scale', 120],
    ['.luvf-faq details', 'rise', 45],
    ['.luvf-cmp-row', 'rise', 30],
    ['.luvf-nut div', 'rise', 60],
    ['.luvf-final h2, .luvf-final p, .luvf-final .luvf-btn', 'rise', 90],
    ['.luvf-note', 'fade', 0],
    ['.luvf-star-media, .luvf-star-buy > *', 'rise', 60]
  ];

  function tag(root) {
    GROUPS.forEach(function (g) {
      root.querySelectorAll(g[0]).forEach(function (el, i) {
        if (el.hasAttribute('data-lv')) return;
        el.setAttribute('data-lv', g[1]);
        if (g[2]) el.style.setProperty('--lv-d', (i % 8) * g[2] + 'ms');
      });
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('lv-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function init(root) {
    root = root || document;
    tag(root);
    root.querySelectorAll('[data-lv]:not(.lv-in)').forEach(function (el) { io.observe(el); });
  }

  function revealAbove() {
    document.querySelectorAll('[data-lv]:not(.lv-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('lv-in');
    });
  }

  var floats = [];
  function collectFloats() { floats = [].slice.call(document.querySelectorAll('.luvf-float')); }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      document.documentElement.classList.toggle('luvf-scrolled', y > 40);
      for (var i = 0; i < floats.length; i++) {
        floats[i].style.setProperty('--lv-py', (y * [0.08, -0.14, 0.18, -0.1][i % 4]).toFixed(1) + 'px');
      }
      ticking = false;
    });
  }

  /* Smooth anchors - ONLY for links inside LUVF sections. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('.luvf a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id === '#') return;
    var t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  });

  function boot() { init(document); collectFloats(); revealAbove(); onScroll(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { collectFloats(); revealAbove(); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target); collectFloats(); revealAbove();
  });
})();

/* ============================================================
   LUVF header dropdowns - hover intent, 19 Aug 2026.

   Dawn opens its <details> menus on click and snaps them shut.
   This gives them the behaviour a considered site has:
     - opens ~90ms after the pointer arrives, so sweeping across
       the nav does not fire every panel
     - stays open ~420ms after the pointer leaves, so you can
       travel diagonally down to a link without it vanishing
     - fades out over 220ms instead of disappearing

   Pointer-with-hover only: touch and keyboard keep Dawn's own
   click/focus behaviour untouched.

   ---------------------------------------------------------------
   BUG FIXED 19 Aug 2026 - the mega menu shut the instant the
   pointer moved into it.

   The old version wired EVERY <details> under .header__inline-menu.
   The mega panel is built from nested details: each column inside it
   (Dishes, Sides, Snacks...) is its own <details>, held permanently
   open by luvf-mega.js. So moving the pointer into the panel entered
   a column's <details>, which fired that column's open() - and open()
   closes every other open <details> in the header, including the very
   panel the pointer was standing in. The menu appeared to slam shut
   the moment you moved.

   Two rules now, and they must both hold:
     1. Only TOP-LEVEL menus get hover behaviour. A <details> that
        sits inside .header__submenu, or carries .luvf-col, is part of
        the panel's furniture and is left alone.
     2. open() only closes its SIBLINGS - other top-level menus -
        never anything nested inside itself.

   If you ever change how the mega menu is built, re-check this file
   first. This is the failure it produces.
   ============================================================ */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 420;
  var FADE_MS = 220;

  /* Top-level only: li > (header-menu >) details. Dawn wraps each one in a
     <header-menu> custom element, so a direct-child selector finds nothing -
     walk from the li instead. */
  function topLevel() {
    var out = [];
    document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (li) {
      var d = li.querySelector('details');
      if (d && !d.closest('.header__submenu') && !d.classList.contains('luvf-col')) out.push(d);
    });
    return out;
  }

  function wire(d) {
    if (d.dataset.luvfHover) return;
    d.dataset.luvfHover = '1';
    var openT = null, closeT = null;

    function cancelClose() {
      if (closeT) { clearTimeout(closeT); closeT = null; }
      d.classList.remove('luvf-nav-closing');
    }

    function open() {
      cancelClose();
      /* siblings only - never a column inside our own panel */
      topLevel().forEach(function (o) {
        if (o !== d && o.hasAttribute('open')) {
          o.classList.remove('luvf-nav-closing');
          o.removeAttribute('open');
        }
      });
      if (!d.hasAttribute('open')) d.setAttribute('open', '');
    }

    function close() {
      if (!d.hasAttribute('open')) return;
      d.classList.add('luvf-nav-closing');
      setTimeout(function () {
        d.classList.remove('luvf-nav-closing');
        d.removeAttribute('open');
      }, FADE_MS);
    }

    d.addEventListener('mouseenter', function () {
      if (closeT) cancelClose();
      openT = setTimeout(open, OPEN_DELAY);
    });

    d.addEventListener('mouseleave', function () {
      if (openT) { clearTimeout(openT); openT = null; }
      closeT = setTimeout(close, CLOSE_DELAY);
    });

    /* a click should still work, and should not be undone by the timers */
    d.addEventListener('click', function () { cancelClose(); });
  }

  function boot() { topLevel().forEach(wire); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  /* the mega panel is assembled by luvf-mega.js on DOMContentLoaded, so run
     again afterwards in case the columns appeared after the first pass */
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();